module.exports = __webpack_public_path__ + "static/cover-2bc4fd4e6ac31a9db8da244aa5386250.png";